exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".right-box[data-v-30eb6b41] {\n  padding: 20px;\n  height: 90vh;\n}", ""]);

// exports
